import { Controller } from "@hotwired/stimulus";
import * as Turbo from "@hotwired/turbo";

export default class extends Controller {
  static values = {
    url: String,
    interval: { type: Number, default: 3000 },
    maxAttempts: { type: Number, default: 60 },
  };

  connect() {
    this._attempts = 0;
    this._inflight = false;
    this._poll = setInterval(() => this._check(), this.intervalValue);
  }

  disconnect() {
    clearInterval(this._poll);
  }

  async _check() {
    if (this._inflight) return;
    if (this._attempts >= this.maxAttemptsValue) {
      clearInterval(this._poll);
      return;
    }

    this._inflight = true;
    this._attempts++;

    try {
      const response = await fetch(this.urlValue, {
        headers: {
          Accept: "text/vnd.turbo-stream.html",
          "X-CSRF-Token": document.querySelector("[name='csrf-token']").content,
        },
      });

      if (response.status === 200) {
        const html = await response.text();
        Turbo.renderStreamMessage(html);
        clearInterval(this._poll);
      }
    } catch {
      // Retry on next interval
    } finally {
      this._inflight = false;
    }
  }
}
